import { render, staticRenderFns } from "./PreperationPage.vue?vue&type=template&id=5b2c2abb&scoped=true&"
import script from "./PreperationPage.vue?vue&type=script&lang=js&"
export * from "./PreperationPage.vue?vue&type=script&lang=js&"
import style0 from "./PreperationPage.vue?vue&type=style&index=0&id=5b2c2abb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2c2abb",
  null
  
)

export default component.exports